module.exports = __webpack_public_path__ + "img/second-section-bg.b2c8f8d8.svg";